export const createTabelaPrecoModel = ({
  id_tabela_preco = '',
  tabela_preco = '',
  data_inicial = '',
  data_final = '',
  itens = []
} = {}) => ({
  id_tabela_preco,
  tabela_preco,
  data_inicial,
  data_final,
  itens
});